import {validarCnpj} from './cnpj';

class Rules {
  static required = (field, type='string') => {
    return {
      rules: [
        {type, required: true, message: (field ? `${field} é ` : 'Campo ') + 'obrigatório'},
      ],
    };
  }
  static fullname = {
    rules: [
      {required: true, message: 'Campo nome obrigatório.'},
      {
        message: 'Favor preencher com nome completo',
        validator: (rule, value, callback) => {
          const nonEmptyWords = value.split(' ').filter((x) => x.length).length;
          if (nonEmptyWords < 2) {
            return callback('Favor preencher com nome completo');
          }
          return callback();
        },
      },
    ],
  }
  static cnpj = {
    rules: [
      {type: 'string', required: true, message: 'CNPJ é obrigatório'},
      {
        validator: (rule, value, callback) => {
          if (!value) return callback();
          // Valida CNPJ numérico e alfanumérico pelo módulo único (SERPRO).
          if (!validarCnpj(value)) {
            return callback('CNPJ inválido');
          }
          return callback();
        },
      },
    ],
  }
  static email = {
    rules: [
      {type: 'string', required: true, message: 'E-mail é obrigatório'},
      // eslint-disable-next-line
      {type: 'email', pattern: '/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i', message: 'E-mail inválido'},
    ],
  }
  static telefone = {
    rules: [
      {type: 'string', required: true, message: 'Telefone é obrigatório'},
      {
        validator: (rule, value, callback) => {
          if (value && value.replace( /\D+/g, '').length < 10) {
            return callback(new Error());
          }
          return callback();
        },
        message: 'Informe um telefone válido',
      },
    ],
  }
  static dataAgendamento = {
    rules: [
      {type: 'object', required: true, message: 'A data de agendamento é obrigatória'},
    ],
  }
}

export default Rules;
